module.exports = __webpack_public_path__ + "static/media/send-back.3cad99e6.svg";